export const DEFAULT_COLUMN_CONFIG = {
  size: 150,
  minSize: 50,
  maxSize: 500,
}
